<template>
     <div class="assembly">
         <div class="m-left">
            <div class="lll">
                <span></span> 选择图片
            </div>
              <el-upload
                                    action=""
                                    :show-file-list="false"
                                    :auto-upload="false"
                                    accept="image/*"
                                    list-type="picture-card"
                                    :on-change="zhutiImg_fn"
                                >
                                
                                     <el-button size="small" type="primary" class="zhuti-img last-el-button" >上传自定义图片</el-button>
                         </el-upload>
         </div>
         <div class="select">
             <el-scrollbar style="height:95%;width: 100%;">
            <div :class="['select-item',{'active':selectIndex == index}]" v-for="(item,index) in selectList" :key="index"  @click="selectIndex = index">
                <div class="item-img">
                    <img :src="item.url" alt="" draggable="true" @dragend="dragend_fn($event,index)">
                </div>
            </div>
               </el-scrollbar>

         </div>
        <div class="m-left">
            <div>
                <span></span> 编辑属性
            </div>
        </div>
         <div class="style-con" v-show="determine">
             <div class="style-item">
                  <span>宽度</span>
                 <el-input-number v-model="widthNum" controls-position="right"  :min="1" :max="2000" @change="change_fn"></el-input-number>
                 <span>(px)</span>
            </div>
             <div class="style-item">
                  <span>高度</span>
                  <el-input-number v-model="heightNum" controls-position="right"  :min="1" :max="2000" @change="change_fn"></el-input-number>
                  <span>(px)</span>
            </div>
             <div class="style-item">
                  <span>X轴</span>
                 <el-input-number v-model="leftPx" controls-position="right"  :min="1" :max="2000" @change="change_fn"></el-input-number>
                 <span>(px)</span>
            </div>
             <div class="style-item">
                  <span>Y轴</span>
                 <el-input-number v-model="topPx" controls-position="right"  :min="1" :max="2000" @change="change_fn"></el-input-number>
                 <span>(px)</span>
            </div>
       
       
        </div>
        
       
        
        
    </div>
</template>

<script>
export default {
//    props:['galleryObj'],
 props: {
         galleryObj: {
            type: Object,
            default: () => ({})
        },
        
        },
    data() {
        return {
            //图片
            selectList:[],
            selectIndex:-1,
            num:60,
            widthNum:60,
            heightNum:60,
            leftPx:60,
            topPx:60,
            determine:false
        };
    },

    mounted() {
        for(let i = 1;i<=8;i++){
            this.selectList.push({
                url:require(`@/assets/customKanBan/图库/example${i}.png`)
            })
        }
    },
    watch:{
        galleryObj(val){
             if(JSON.stringify(val) != '{}'){
                 this.determine =  true
                 var data =  JSON.parse(JSON.stringify(val))
                 this.widthNum = this.tranString(data.info.width)
                 this.heightNum = this.tranString(data.info.height)
                 this.leftPx =  this.tranString(data.info.left)
                 this.topPx =  this.tranString(data.info.top)
                 this.selectIndex  = data.itemIndex

             }else {
                 this.determine =  false
             }
        },
    },

    methods: {
         tranString(str){
         return Number(str.replace(/px/g, ""))
      },
         zhutiImg_fn(file){
            const reader = new FileReader();
            
            reader.onload = (event) => {
                this.selectList.push({'url':reader.result})
                const image = new Image();
                
                // 当图像准备好时执行回调函数
                image.onload = () => {
                    this.selectList[this.selectList.length - 1].width = image.width
                    this.selectList[this.selectList.length - 1].height = image.height
                };
                
                image.src = event.target.result;
            };
               reader.readAsDataURL(file.raw);
            
        },
         //拖放
        dragend_fn(e,index){
           var clientX = e.clientX
            var clientY = e.clientY
            var newWidth = ""
            var newHeght = ""
             if(index == 0 || index == 1 || index == 2){
                 newWidth = '60px'
                 newHeght = '60px'
              }else if(index == 3){
                newWidth = '76px'
                 newHeght = '32px'
              }else if(index == 4){
                newWidth = '86px'
                 newHeght = '85px'
              }else if(index == 5){
                newWidth = '200px'
                 newHeght = '200px'
              }else if(index == 6 || index == 7){
                newWidth = '24px'
                 newHeght = '4px'
              }else{
                newWidth = this.selectList[index].width+'px'
                 newHeght = this.selectList[index].height+'px'
              }
            var d  = {
                 'clientX':clientX, 
                 'clientY':clientY,
                 'tabIndex':7,
                 'itemWidth':this.widthNum,
                 'itemHeight':this.heightNum,
                 'imgUrl':this.selectList[index].url,
                 'itemIndex':index,
                 'initialWidth': e.target.offsetWidth,
                 'initialHeight': e.target.offsetHeight,
                 'newWidth': newWidth,
                 'newHeght': newHeght,

                //  'itemX':this.xNum,
                //  'itemY':this.yNum,

            }

             this.$emit('gallery_fn',d)
        },
        //变化
        change_fn(){
           if(this.selectIndex != -1){
              var d  = {
                'widthNum':this.widthNum,
                'heightNum':this.heightNum,
                'leftPx':this.leftPx,
                'topPx':this.topPx,
              }
                this.$emit('changGallery_fn',d)
           }
        }
    },
};
</script>

<style lang="scss" scoped>
.assembly{
    .m-left {
        color: #359EFF;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
            background-color: #359EFF;
            display: inline-block;
            width: 2px;
            height: 12px;
            margin-right: 4px;

        }
    }
    .select {
        width: 100%;
        height: 350px;
       display: flex;
       flex-wrap: wrap;
       justify-content: space-between;
       margin-bottom: 40px;
        margin-top: 15px;
        .select-item {
            width: 31%;
            height: 100px;
            background-color: #000000;
            margin-bottom: 15px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
             transition: all 0.3s;
            border: 2px solid transparent;
            .item-img {
                width: 95%;
                height: 68px;
                margin-top: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    max-width: 95%;
                    max-height: 95%;
                }

            }
            &.active {
                border: 2px solid #0085FF;

            }
     
          &:hover {
				/* 鼠标悬浮时盒子出现的阴影 */
                //    box-shadow: 0px 1px 12px 0px #cccccc;
				transform: translate(0, -5px);/* 鼠标悬浮时盒子上移10px */
			}
            p {
                color: #999999;
            }
        }
    }
    
    .style-con {
            .style-item {
                
                display: flex;
                align-items: center;
                margin-top: 20px;
               
                span {
                    margin-right: 20px;
                    display: inline-block;
                    width: 30px;
                     text-align: right;
                }
                p {
                    margin-left: 4px;
                    color: #999999;
                }
            }
            /deep/.el-checkbox {
                margin-right: 20px;
                color: #999999;
            }
            /deep/.el-checkbox__label {
                padding-left: 4px;
            }
            /deep/.el-input-number{
                line-height: 34px;
            }
            /deep/.el-input-number.is-controls-right .el-input-number__decrease, .el-input-number.is-controls-right .el-input-number__increase{
                line-height: 17px;
            }
            /deep/.el-input__inner {
                height: 36px;
                line-height: 36px;
            }
        }
    



}
</style>